import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { Typography, useTheme } from '@mui/material';
import {
  JUDGEMENT,
  JUDGEMENT_LABEL,
  NG_DELAY,
} from '../../../../../_constants/inspectionConst';
import { useDispatch } from 'react-redux';
import { updateJudgement } from '../../../../../stores/inspectionTypeData/slice';
import {
  getColorByJudgement,
  isEmpty,
  isNa,
  isNg,
  isOk,
} from '../../../../../_utils/inspectionUtils';

type CheckBoxProps = {
  itemId: string;
  categoryId: string;
  typeId: string;
  path: string[];
  judgement: number;
  onOk?: () => void;
  onNg?: () => void;
  onNa?: () => void;
  borderColor?: string;
  isUnfilled: boolean;
};

const CheckBox: React.FC<CheckBoxProps> = ({
  itemId,
  categoryId,
  typeId,
  path,
  judgement,
  onOk = () => {},
  onNg = () => {},
  onNa = () => {},
  borderColor,
  isUnfilled,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  // 初回表示が完了したか
  const [isFinishFirstDisplay, setIsFinishFirstDisplay] = useState(false);
  // クリックによる変更かどうか
  const [isChangeByClick, setIsChangeByClick] = useState(false);

  useEffect(() => {
    setIsFinishFirstDisplay(false);
  }, [categoryId, typeId]);

  const handleTap = () => {
    setIsChangeByClick(true);
    switch (judgement) {
      case JUDGEMENT.EMPTY:
      case JUDGEMENT.NA:
        dispatch(
          updateJudgement({
            categoryId,
            typeId,
            path,
            judgement: JUDGEMENT.OK,
          }),
        );
        break;
      case JUDGEMENT.OK:
        dispatch(
          updateJudgement({
            categoryId,
            typeId,
            path,
            judgement: JUDGEMENT.NG,
          }),
        );
        break;
      case JUDGEMENT.NG:
        dispatch(
          updateJudgement({
            categoryId,
            typeId,
            path,
            judgement: JUDGEMENT.NA,
          }),
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      // タブ切り替え直後は実行しない
      if (!isFinishFirstDisplay) {
        setIsFinishFirstDisplay(true);
        return;
      }
      // 返品修理ボタンで結果が自動入力されるときは実行しない
      if (!isChangeByClick) {
        return;
      }

      setIsChangeByClick(false);

      if (isOk(judgement)) {
        onOk();
      }
      if (isNg(judgement)) {
        onNg();
      }
      if (isNa(judgement)) {
        onNa();
      }
    }, NG_DELAY);
    return () => clearTimeout(timer);
  }, [judgement]);

  return (
    <Button
      id={itemId}
      variant="outlined"
      onClick={handleTap}
      sx={{
        margin: '3px 0',
        height: '35px',
        width: '35px',
        minWidth: 'auto',
        bgcolor:
          isEmpty(judgement) && isUnfilled
            ? theme.palette.warning.light
            : theme.palette.background.default,
        color: getColorByJudgement(judgement),
        borderColor: borderColor ? borderColor : '',
      }}
    >
      <Typography sx={{ fontSize: theme.typography.button.fontSize }}>
        {JUDGEMENT_LABEL[judgement]}
      </Typography>
    </Button>
  );
};

export default CheckBox;
